<template>
  <div class="solutions __vehicles">
    <div class="vehicles">
      <div class="vehicle-drilldown">
        <div class="form">
          <div class="form-content">
            <div class="form-row">
              <label for>{{ label_manufacturer }}</label>
              <select
                name
                :id="label_manufacturer"
                v-model="manufacturerId"
                dusk="Manufacturer"
                @change="selectVehicle($event)"
                :disabled="form_submitted"
              >
                <option value="0" disabled>{{ label_select }}</option>
                <optgroup
                  label="- Popular Makes -"
                  v-if="popularManufacturers && popularManufacturers.length > 0"
                >
                  <option
                    v-for="(popularManufacturer, index) in popularManufacturers"
                    :key="index"
                    :id="popularManufacturer.manufacturerId"
                    :value="popularManufacturer.manufacturerId"
                    :dusk="popularManufacturer.title"
                  >
                    {{ popularManufacturer.title }}
                  </option>
                </optgroup>
                <optgroup :label="getAllMakesLabel">
                  <option
                    v-for="(manufacturer, index) in manufacturers"
                    :key="index"
                    :id="manufacturer.manufacturerId"
                    :value="manufacturer.manufacturerId"
                    :dusk="manufacturer.title"
                  >
                    {{ manufacturer.title }}
                  </option>
                </optgroup>
              </select>
            </div>

            <div class="form-row">
              <label for>{{ label_model }}</label>
              <select
                name
                :id="label_model"
                v-model="modelId"
                :disabled="models.length == 0 || form_submitted"
                dusk="Model"
                @change="selectVehicle($event)"
              >
                <option value="0" disabled>{{ label_select }}</option>
                <optgroup
                  label="- Popular Models -"
                  v-if="popularModels && popularModels.length > 0"
                >
                  <option
                    v-for="(popularModel, index) in popularModels"
                    :key="index"
                    :id="popularModel.modelId"
                    :value="popularModel.modelId"
                    :dusk="popularModel.title"
                  >
                    {{ popularModel.title }}
                  </option>
                </optgroup>
                <optgroup :label="getAllModelsLabel">
                  <option
                    v-for="(model, index) in models"
                    :key="index"
                    :id="model.modelId"
                    :value="model.modelId"
                    :dusk="model.title"
                  >
                    {{ model.title }}
                  </option>
                </optgroup>
              </select>
            </div>

            <div class="form-row">
              <label for>{{ label_year }}</label>
              <select
                name
                :id="label_year"
                v-model="year"
                :disabled="years.length == 0 || form_submitted"
                dusk="Year"
                @change="selectVehicle($event)"
              >
                <option value="0" disabled>{{ label_select }}</option>
                <option
                  v-for="(year, index) in years"
                  :key="index"
                  :value="year"
                  :dusk="'year_' + year"
                >
                  {{ year }}
                </option>
              </select>
            </div>

            <div class="form-row">
              <label for>{{ label_body_type }}</label>
              <select
                name
                id="body_type"
                v-model="bodyTypeId"
                :disabled="bodyTypes.length == 0 || form_submitted"
                dusk="body_type"
                @change="selectVehicle($event)"
              >
                <option value="0" disabled>{{ label_select }}</option>
                <option
                  v-for="(bodyType, index) in bodyTypes"
                  :key="index"
                  :value="bodyType.bodyTypeId"
                  :dusk="'body_type_' + bodyType.title"
                >
                  {{ bodyType.title }}
                </option>
              </select>
            </div>

            <!-- hidden for forms wizard -->
            <!-- hidden for forms wizard -->
            <!-- hidden for forms wizard -->
            <div class="vehicle-selection" v-show="vehicles.length > 0">
              <p>{{ label_select_vehicle }}</p>
              <div v-for="(vehicle, index) in vehicles" :key="index">
                <input
                  style="width:unset;appearance:auto;"
                  type="radio"
                  :id="vehicle.Vehicle.vehicleId"
                  name="vehicleId"
                  :value="vehicle.Vehicle"
                  v-model="newSelectedVehicle"
                  @click="setVehicleFullName(vehicle.Vehicle.full_name)"
                  :dusk="'vehicle_' + vehicle.Vehicle.full_name"
                />
                <label :for="vehicle.Vehicle.vehicleId">{{
                  vehicle.Vehicle.full_name
                }}</label>
              </div>

              <button
                v-if="for_load_calc"
                dusk="select_vehicle"
                class="btn btn-hover btn-primary"
                @click="selectVehicle()"
                type="button"
              >
                {{ label_select_vehicle }}
              </button>
            </div>
            <!-- hidden for forms wizard -->
            <!-- hidden for forms wizard -->
            <!-- hidden for forms wizard -->

            <div class="overlay" v-show="loading" dusk="loading_overlay">
              <p class="loading">
                <img src="/cdn/images/loading.gif" width="100" />
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sortPopularList from "../mixins/sortPopularList";

export default {
  name: "form-wizard-vehicle",
  mixins: [sortPopularList],
  props: {
    selectedVehicle: {
      type: Object,
    },
    form_submitted: {
      type: Boolean,
      default: false,
    },
    for_load_calc: {
      type: Boolean,
      default: false,
    },
    link: {
      type: String,
    },
    form_field_id: {
      type: String,
    },
    vehicle_type_id: {
      default: null,
    },
    label_manufacturer: {
      type: String,
      default: "Manufacturer",
    },
    label_model: {
      type: String,
      default: "Model",
    },
    label_year: {
      type: String,
      default: "Year",
    },
    label_body_type: {
      type: String,
      default: "Body Type",
    },
    label_loading: {
      type: String,
      default: "Loading"
    },
    label_select: {
      type: String,
      default: "Select",
    },
    label_select_vehicle: {
      type: String,
      default: "Select Vehicle",
    },
  },
  data() {
    return {
      manufacturers: [],
      manufacturerId: 0,
      models: [],
      modelId: 0,
      years: [],
      year: 0,
      bodyTypes: [],
      bodyTypeId: 0,
      vehicles: [],
      loading: true,
      newSelectedVehicle: {},
      vehicleDetails: '',
    }
  },
  computed: {
    fullUrl() {
      return `/${window.culture}${this.link}`;
    },
    selectedVehicleModel: {
      get: function () {
        return this.selectedVehicle;
      },
      set: function (vehicle) {
        this.newSelectedVehicle = vehicle;
      },
    },
    queryString() {
      if (this.vehicle_type_id) {
        return "?type_id=" + this.vehicle_type_id;
      }
      return "";
    },
    popularManufacturers() {
        return this.sortPopularList(this.manufacturers);
    },
    getAllMakesLabel() {
      if (this.popularManufacturers && this.popularManufacturers.length > 0) {
        return "- All Makes -";
      }
      return "";
    },
    popularModels() {
        return this.sortPopularList(this.models);
    },
    getAllModelsLabel() {
      if (this.popularModels && this.popularModels.length > 0) {
        return "- All Models -";
      }
      return "";
    },
  },
  mounted() {
    this.getVehicleManufacturers();
  },
  methods: {
    selectVehicle(evt) {
      // if input type is not a button
      if (evt) {
        let selectedValue =
          evt.target.options[evt.target.selectedIndex].getAttribute("dusk");
        let inputName = evt.target.id;
        ga("send", "event", "Load Rating Calulator", inputName, selectedValue);
        gtag('event', 'load_rating_calculator', {'category':'Load Rating Calulator', 'action':inputName, 'value': selectedValue});
      }

      let manufacturer = this.manufacturers.find((obj) => {
        return obj.manufacturerId === this.manufacturerId;
      });

      let model = this.models.find((obj) => {
        return obj.modelId === this.modelId;
      });

      let bodyType = this.bodyTypes.find((obj) => {
        return obj.bodyTypeId === this.bodyTypeId;
      });

      manufacturer = manufacturer ? manufacturer.title : "";
      model = model ? model.title : "not_selected";
      bodyType = bodyType ? bodyType.title : "not_selected";

      this.vehicleDetails = manufacturer + " | " + model + " | " + this.year + " | " + bodyType + " | " + "not_selected";

      this.$emit("selectVehicleForm", {
        data: {
          form_field_id: this.form_field_id,
          value: this.vehicleDetails
        }
      });

      this.$emit("selectVehicleLoadrating", {
        data: {
          form_field_id: this.form_field_id,
          manufacturerId: this.manufacturerId,
          modelId: this.modelId,
          year: this.year,
          bodyTypeId: this.bodyTypeId,
          vehicle: this.newSelectedVehicle,
        },
      });
    },
    setVehicleFullName(name) {

        let vehicleDetailsArray = this.vehicleDetails.split(" | ");
        // vehicle full name
        vehicleDetailsArray[4] = name;

        this.vehicleDetails = vehicleDetailsArray.join(" | ");

        this.$emit("selectVehicleForm", {
        data: {
          form_field_id: this.form_field_id,
          value: this.vehicleDetails,
        }
      });
    },
    async getVehicleManufacturers() {
      let response = await axios.get(`api/vehicle/makes${this.queryString}`);
      this.manufacturers = response.data.data;
      this.loading = false;
    },
  },
  watch: {
    async manufacturerId() {
      this.modelId = 0;
      this.loading = true;
      try {
        let url = `api/vehicle/models/${this.manufacturerId}${this.queryString}`;
        let response = await axios.get(url);
        this.models = response.data.data;
        if (this.models.length == 1) {
          this.modelId = this.models[0].modelId;
        }
        this.loading = false;
      } catch (err) {}
    },
    async modelId() {
      this.year = 0;
      this.loading = true;
      try {
        let url = `api/vehicle/model/years/${this.modelId}${this.queryString}`;
        let response = await axios.get(url);
        this.years = response.data.data;
        if (this.years.length == 1) {
          this.year = this.years[0];
        }
        this.loading = false;
      } catch (err) {}
    },
    async year() {
      this.bodyTypeId = 0;
      this.loading = true;
      try {
        let url = `api/vehicle/model/body-types/${this.modelId}/${this.year}${this.queryString}`;
        let response = await axios.get(url);
        this.bodyTypes = response.data.data;
        if (this.bodyTypes.length == 1) {
          this.bodyTypeId = this.bodyTypes[0].bodyTypeId;
        }
        this.loading = false;
      } catch (err) {}
    },
    async bodyTypeId() {
      this.loading = true;
      try {
        let url = `api/vehicle/retrieve/${this.modelId}/${this.year}/${this.bodyTypeId}${this.queryString}`;
        let response = await axios.get(url);
        this.vehicles = response.data.data;
        // if (this.vehicles.length == 1) {
        //   this.newSelectedVehicle = this.vehicles[0].Vehicle;
        // }
        this.loading = false;
      } catch (err) {}
    },
  },
};
</script>
